import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useHistory } from "react-router";
import { createDocumentsTaskUrl, createDocumentsUrl } from "src/pages/authenticated/Routes";

import { POST, type DocWorkflowStepQuestionDatum } from "~utils";

import { getAttributes } from "../utils";

type UseAttrParams = {
  taskId: string | undefined;
  stepId: number | undefined;
};

export function useAttr({ taskId, stepId }: UseAttrParams) {
  const history = useHistory();
  const queryClient = useQueryClient();
  const {
    mutate: updateAttributes,
    isPending,
    isError,
  } = useMutation({
    mutationFn: (state: DocWorkflowStepQuestionDatum[] | undefined) => {
      if (!taskId) {
        throw new Error("useAttr: task id is required");
      }
      return POST("/api/sub/documents/workflow", {
        "task-id": taskId.toLowerCase(),
        attributes: getAttributes(state),
      });
    },
    onSuccess: (response) => {
      void queryClient.invalidateQueries({ queryKey: ["sub", "documents"] });
      if (taskId) {
        void queryClient.invalidateQueries({
          queryKey: ["sub", "documents", "workflow", taskId.toLowerCase()],
        });
      }
      if (response.data.step.isStepBlocked && stepId != null && stepId > response.data.stepIdx) {
        return;
      }
      if (taskId != null && stepId != null) {
        history.push(createDocumentsTaskUrl(taskId.toLowerCase(), String(stepId)));
      } else if (taskId) {
        history.push(createDocumentsTaskUrl(taskId.toLowerCase()));
      } else {
        history.push(createDocumentsUrl());
      }
    },
    retry: 2,
    onError: (error) => {
      // eslint-disable-next-line no-console
      console.error("useAttr error:", error);
    },
  });

  return { updateAttributes, isPending, isError };
}
